(function yizchoInteractionAnalytics() {
  "use strict";

  var EVENT_DEFINITIONS = {
    island_entered: {
      shopify: "yizcho:island_entered",
      klaviyo: "Yizcho Island Entered",
    },
    island_mail_opened: {
      shopify: "yizcho:island_mail_opened",
      klaviyo: "Yizcho Island Mail Opened",
    },
    kickstarter_cta_clicked: {
      shopify: "yizcho:kickstarter_cta_clicked",
      klaviyo: "Yizcho Kickstarter CTA Clicked",
    },
    island_interaction: {
      shopify: "yizcho:island_interaction",
      klaviyo: null,
    },
  };
  var SESSION_PREFIX = "yizcho:analytics:";
  var ATTRIBUTION_KEY = "yizcho:analytics:first-attribution";
  var SEQUENCE_KEY = SESSION_PREFIX + "interaction-sequence";
  var SAFE_TOKEN = /^[a-z0-9][a-z0-9_-]{0,79}$/;
  var KICKSTARTER_SELECTOR = [
    "#launch-house-intro-subscribe",
    ".launch-house__kickstarter",
    "#launch-product-cta",
    "a[href='#island-mail']",
  ].join(",");
  var MAIL_SELECTOR = [
    "#mail-bird",
    "[data-drawer-action='letter']",
    "#drop-house-alert",
    KICKSTARTER_SELECTOR,
  ].join(",");
  var pendingMailSource = "unknown";
  var letterWasOpen = document.body.classList.contains("letter-open");
  var lastSemanticSignature = "";
  var lastSemanticTime = 0;

  function safeSessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function safeSessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      // Analytics must never interrupt the island experience.
    }
  }

  function readStoredAttribution() {
    try {
      var value = JSON.parse(window.localStorage.getItem(ATTRIBUTION_KEY) || "null");
      return value && typeof value === "object" ? value : {};
    } catch (_error) {
      return {};
    }
  }

  function storeAttribution(value) {
    try {
      window.localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(value));
    } catch (_error) {
      // Attribution persistence is optional.
    }
  }

  function safeToken(value, fallback) {
    var normalized = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 80);
    return SAFE_TOKEN.test(normalized) ? normalized : (fallback || "unknown");
  }

  function attribution() {
    var params = new URLSearchParams(window.location.search);
    var referrerHost = "";
    var current = {};
    try {
      referrerHost = document.referrer ? new URL(document.referrer).hostname : "";
    } catch (_error) {
      referrerHost = "";
    }
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (key) {
      var value = params.get(key);
      if (value) current[key] = value.slice(0, 160);
    });
    var first = readStoredAttribution();
    if (!Object.keys(first).length && (Object.keys(current).length || referrerHost)) {
      first = Object.assign({ referrer_host: referrerHost }, current);
      storeAttribution(first);
    }
    var effective = Object.keys(current).length ? current : first;
    return {
      page_path: window.location.pathname,
      utm_source: effective.utm_source || "",
      utm_medium: effective.utm_medium || "",
      utm_campaign: effective.utm_campaign || "",
      utm_content: effective.utm_content || "",
      utm_term: effective.utm_term || "",
      first_utm_source: first.utm_source || "",
      first_utm_medium: first.utm_medium || "",
      first_utm_campaign: first.utm_campaign || "",
      first_utm_content: first.utm_content || "",
      first_utm_term: first.utm_term || "",
      referrer_host: referrerHost || first.referrer_host || "",
      device_class: window.matchMedia("(max-width: 759px)").matches ? "mobile" : "desktop",
    };
  }

  function publishClarity(eventKey, payload) {
    try {
      if (typeof window.clarity !== "function") return;
      var action = eventKey === "island_interaction"
        ? safeToken(payload.action, "interaction")
        : safeToken(eventKey, "interaction");
      window.clarity("event", "yizcho_" + action);
      if (payload.target && payload.target !== "unknown") {
        var interest = safeToken(payload.target, "unknown");
        var interestKey = SESSION_PREFIX + "clarity-interest:" + interest;
        if (safeSessionGet(interestKey) !== "1") {
          window.clarity("set", "yizcho_interest", interest);
          safeSessionSet(interestKey, "1");
        }
      }
    } catch (_error) {
      // Clarity can be unavailable when privacy tools block it.
    }
  }

  function publishProviders(eventKey, payload) {
    var definition = EVENT_DEFINITIONS[eventKey];
    if (!definition) return false;

    try {
      if (window.Shopify && window.Shopify.analytics
        && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(definition.shopify, payload);
      }
    } catch (_error) {
      // Provider failures are intentionally isolated from storefront behavior.
    }

    try {
      if (definition.klaviyo && window.klaviyo
        && typeof window.klaviyo.track === "function") {
        window.klaviyo.track(definition.klaviyo, payload);
      } else if (definition.klaviyo) {
        window._learnq = window._learnq || [];
        window._learnq.push(["track", definition.klaviyo, payload]);
      }
    } catch (_error) {
      // Detailed exploration events intentionally do not enter Klaviyo.
    }

    publishClarity(eventKey, payload);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event: definition.shopify.replace(":", "_"),
      }, payload));
    } catch (_error) {
      // A missing tag manager must not block the island.
    }

    try {
      window.dispatchEvent(new CustomEvent("yizcho:analytics", {
        detail: {
          eventKey: eventKey,
          eventName: definition.shopify,
          properties: payload,
        },
      }));
    } catch (_error) {
      // The DOM event is an optional integration hook.
    }
    return true;
  }

  function publish(eventKey, properties) {
    var definition = EVENT_DEFINITIONS[eventKey];
    var sessionKey = SESSION_PREFIX + eventKey;
    if (!definition || safeSessionGet(sessionKey) === "1") return false;
    safeSessionSet(sessionKey, "1");
    return publishProviders(eventKey, Object.assign({}, attribution(), properties || {}));
  }

  function nextSequence() {
    var current = Number(safeSessionGet(SEQUENCE_KEY)) || 0;
    var next = Math.min(current + 1, 9999);
    safeSessionSet(SEQUENCE_KEY, String(next));
    return next;
  }

  function publishSemantic(action, target, source, extra) {
    var cleanAction = safeToken(action, "interaction");
    var cleanTarget = safeToken(target, "unknown");
    var cleanSource = safeToken(source, "island");
    var now = Date.now();
    var signature = [cleanAction, cleanTarget, cleanSource].join(":");
    if (signature === lastSemanticSignature && now - lastSemanticTime < 450) return false;
    lastSemanticSignature = signature;
    lastSemanticTime = now;

    var payload = Object.assign({}, attribution(), {
      action: cleanAction,
      target: cleanTarget,
      source: cleanSource,
      sequence: nextSequence(),
    });
    if (extra) {
      ["method", "direction", "step", "status"].forEach(function addSafeExtra(key) {
        if (extra[key]) payload[key] = safeToken(extra[key], "unknown");
      });
    }
    return publishProviders("island_interaction", payload);
  }

  function sourceFor(control) {
    if (!control) return "unknown";
    if (control.id) return safeToken(control.id);
    if (control.matches("[data-drawer-action='letter']")) return "island-menu";
    if (control.matches(".launch-house__kickstarter")) return "launch-house-subscribe";
    return "island-experience";
  }

  function selectedHouse() {
    var selected = document.querySelector("[data-id].is-selected");
    return selected ? safeToken(selected.getAttribute("data-id"), "unknown") : "unknown";
  }

  function classifyControl(control) {
    if (!control) return null;
    var id = control.id || "";
    var houseId = control.getAttribute("data-id");
    var drawerHouse = control.getAttribute("data-drawer-house");
    var drawerAction = control.getAttribute("data-drawer-action");
    var launchProduct = control.getAttribute("data-launch-product");
    var archiveProduct = control.getAttribute("data-archive-product");
    var dropArchiveProduct = control.getAttribute("data-drop-archive-product");
    var policy = control.getAttribute("data-island-policy");

    if (control.matches(".hotspot[data-id]")) return ["house_selected", houseId, "island_map"];
    if (control.matches(".index-dot[data-id]")) return ["house_selected", houseId, "house_index"];
    if (drawerHouse) return ["house_selected", drawerHouse, "island_menu"];
    if (id === "brand-home") return ["navigation_opened", "island_menu", "topbar"];
    if (drawerAction === "overview") return ["navigation_selected", "island_overview", "island_menu"];
    if (drawerAction === "about") return ["artist_entry_opened", "artist_castle", "island_menu"];
    if (drawerAction === "tracking") return ["utility_opened", "parcel_tracking", "island_menu"];
    if (drawerAction === "contact") return ["utility_opened", "contact", "island_menu"];
    if (drawerAction === "letter") return ["mail_open_requested", "island_mail", "island_menu"];
    if (drawerAction === "tour") return ["tour_started", "island_tour", "island_menu"];

    if (id === "room-entry" || id === "launch-house-intro-enter") {
      return ["room_entered", selectedHouse(), id === "room-entry" ? "house_closeup" : "kickstarter_intro"];
    }
    if (["room-exit", "closeup-back", "back-button", "panel-close"].indexOf(id) >= 0) {
      return ["island_returned", selectedHouse(), id];
    }
    if (id === "drop-house-alert") return ["drop_alert_opened", "island_mail", "drop_house"];
    if (id === "drop-house-archive-link") return ["archive_opened", "sold_out_archive", "drop_house"];
    if (dropArchiveProduct !== null) return ["archive_product_opened", "drop-" + dropArchiveProduct, "drop_house"];
    if (archiveProduct !== null) return ["archive_product_opened", "archive-" + archiveProduct, "archive_house"];
    if (launchProduct !== null) return ["kickstarter_product_opened", "launch-" + launchProduct, "kickstarter_house"];
    if (id === "launch-gallery-previous" || id === "launch-gallery-next") {
      return ["product_gallery_used", "kickstarter_product", id.indexOf("previous") >= 0 ? "previous" : "next"];
    }
    if (id === "archive-gallery-previous" || id === "archive-gallery-next") {
      return ["product_gallery_used", "archive_product", id.indexOf("previous") >= 0 ? "previous" : "next"];
    }
    if (id === "launch-gallery-expand" || id === "launch-gallery-link") {
      return ["product_gallery_opened", "kickstarter_product", id];
    }
    if (id === "archive-gallery-expand" || id === "archive-gallery-link") {
      return ["product_gallery_opened", "archive_product", id];
    }

    if (id === "review-room-trigger") return ["reviews_opened", "collector_reviews", "review_room"];
    if (id === "review-room-next" || id === "review-room-previous") {
      return ["review_browsed", "collector_reviews", id.indexOf("previous") >= 0 ? "previous" : "next"];
    }
    if (id === "review-room-photo") return ["review_photo_browsed", "collector_review_photo", "review_room"];
    if (id === "review-room-write-review") return ["review_write_opened", "write_review", "review_room"];
    if (control.matches(".review-room__write-product")) return ["review_write_product_selected", "review_product", "review_room"];

    if (id === "tracking-boat") return ["utility_opened", "parcel_tracking", "tracking_boat"];
    if (id === "account-button") return ["account_opened", "island_passport", "topbar"];
    if (control.matches(".island-account__option")) {
      return ["auth_method_selected", control.dataset.authProvider || "shopify", "island_passport"];
    }
    if (id === "castle-about") return ["artist_entry_opened", "artist_castle", "island_map"];
    if (id === "castle-door") return ["artist_studio_entered", "artist_studio", "artist_castle"];
    if (id === "castle-artwork-hotspot") return ["artist_story_opened", "artist_story", "artist_studio"];
    if (id === "artist-story-return") return ["artist_story_closed", "artist_story", "artist_studio"];
    if (policy) return ["policy_opened", policy, "island_menu"];

    if (id === "mail-bird") return ["mail_open_requested", "island_mail", "mail_bird"];
    if (id === "island-letter-skip") return ["mail_dismissed", "email_step", "island_mail"];
    if (id === "island-whatsapp-skip") return ["mail_whatsapp_skipped", "whatsapp_step", "island_mail"];
    if (id === "island-letter-finish") return ["mail_completed", "success_step", "island_mail"];

    var link = control.matches("a[href]") ? control : null;
    if (link) {
      var href = link.getAttribute("href") || "";
      if (/instagram\.com/i.test(href)) return ["social_link_clicked", "instagram", "island_menu"];
      if (/tiktok\.com/i.test(href)) return ["social_link_clicked", "tiktok", "island_menu"];
      if (/youtube\.com/i.test(href)) return ["social_link_clicked", "youtube", "island_menu"];
      if (/wa\.me/i.test(href)) return ["social_link_clicked", "whatsapp", "island_menu"];
    }

    if (KICKSTARTER_SELECTOR.split(",").some(function matchesSelector(selector) {
      return control.matches(selector);
    })) return ["kickstarter_alert_opened", "kickstarter", sourceFor(control)];

    if (id && SAFE_TOKEN.test(id.toLowerCase())) return ["control_clicked", id, "island_interface"];
    return null;
  }

  function maskSensitiveFields(node) {
    if (!(node instanceof Element)) return;
    var selector = "input, textarea, [contenteditable='true']";
    if (node.matches(selector)) node.setAttribute("data-clarity-mask", "true");
    node.querySelectorAll(selector).forEach(function mask(element) {
      element.setAttribute("data-clarity-mask", "true");
    });
  }

  maskSensitiveFields(document.documentElement);
  new MutationObserver(function maskAddedFields(mutations) {
    mutations.forEach(function inspectMutation(mutation) {
      mutation.addedNodes.forEach(maskSensitiveFields);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("click", function handleIslandAnalyticsClick(event) {
    if (!(event.target instanceof Element)) return;
    var control = event.target.closest("button, a[href], [role='button']");
    if (!control) return;

    var mailControl = control.closest(MAIL_SELECTOR);
    if (mailControl) pendingMailSource = sourceFor(mailControl);

    var kickstarterControl = control.closest(KICKSTARTER_SELECTOR);
    if (kickstarterControl) {
      publish("kickstarter_cta_clicked", { source: sourceFor(kickstarterControl) });
    }

    var interaction = classifyControl(control);
    if (interaction) publishSemantic(interaction[0], interaction[1], interaction[2]);
  }, true);

  document.addEventListener("submit", function handleSemanticSubmit(event) {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (event.target.id === "tracking-widget-preview-form") {
      var trackingInput = event.target.querySelector("#tracking-shipment-number");
      publishSemantic(
        "parcel_lookup_attempted",
        trackingInput && trackingInput.value.trim() ? "tracking_number" : "order_lookup",
        "parcel_tracking",
      );
    } else if (event.target.id === "yizcho-contact-form" || event.target.id === "YizchoContactForm") {
      publishSemantic("contact_attempted", "contact_form", "island_contact");
    }
  }, true);

  window.addEventListener("yizcho:island-mail-subscribed", function handleEmailSubscription() {
    publishSemantic("mail_email_subscribed", "email_step", "island_mail");
  });

  window.addEventListener("yizcho:island-mail-failed", function handleEmailSubscriptionFailure(event) {
    var detail = event.detail || {};
    publishSemantic("mail_email_failed", detail.reason || "unknown", "island_mail");
  });

  window.addEventListener("klaviyoForms", function handleWhatsAppSubscription(event) {
    var detail = event.detail || {};
    if (detail.formId !== "SdWvTW") return;
    if (detail.type === "submit") {
      publishSemantic("mail_whatsapp_subscribed", "whatsapp_step", "island_mail");
    } else if (detail.type === "embedOpen") {
      publishSemantic("mail_whatsapp_viewed", "whatsapp_step", "island_mail");
    }
  });

  new MutationObserver(function handleLetterState() {
    var letterIsOpen = document.body.classList.contains("letter-open");
    if (letterIsOpen && !letterWasOpen) {
      publish("island_mail_opened", { source: pendingMailSource });
      pendingMailSource = "unknown";
    }
    letterWasOpen = letterIsOpen;
  }).observe(document.body, { attributes: true, attributeFilter: ["class"] });

  if (document.querySelector("[data-yizcho-preview], .yizcho-preview-shell")) {
    publish("island_entered", { source: "island_home" });
  }
})();
